import { call, put, select, takeLatest } from "redux-saga/effects";
import * as API from "../../../containers/APIurls";
import apiClient from "../../../utils/apiClient";
import * as WCMPSlice from "./WCMPSlice";
import IOTSimdetails from './IOTSimdetails.json'
import axios from "axios";
import * as GlobalSlice from "app/ducks/GlobalSlice";
import * as selectors from "./selectors";
import { initializeCheckout, getSessionCartInfo, getManagerApprovalInfo } from "pages/Checkout/ducks/sagas";



// import { setAPIError, setError, setGridwallList, setPageLoading, setPdpDeviceDetails, setProductDetail } from "pages/Marketplace/ducks/MarketplaceSlice";
let ecpdId;
let zipCode;
const fetchData = async () => {

	//const globalData = yield select(selectors.globalData);
	const requestBody = {
		"ecpdId": ecpdId ?? "",
		"zipCode": zipCode ?? ""
	};
	try {
		//devicesvc/mbt/device-composite/v1/sim/iot-details/get	
		//https://mbqa1.sdc.vzwcorp.com/mbt/prospect/devicesvc/mbt/device-composite/v1/sim/iot-details/get			
		const config = {
			headers: {
				'Content-Type': 'application/json',
			}
		}
		const resp = await apiClient.post(
			API.GET_IOT_SIMDETAILS,
			//"https://mbqa2.sdc.vzwcorp.com/mbt/prospect/cartcompsvc/shop/product/accessory/sim/addCart",
			requestBody,
			config
		);
		return resp?.data?.response;
	} catch (error) {
		//console.error(error);
		return null;
	}
};

function* getIOTSimdetails() {
	try {
		yield put(WCMPSlice.setPageLoading(true));
		// const globalData = yield select(selectors.globalData);
		// const useMock = false;
		// //const requestBody = params.payload
		// const apiPayload = {
		//    "request": {
		// 	"ecpdId": globalData?.widgetInputParams?.ecpdId?.value ?? ""               
		//     }            
		// }
		// const config = {
		// 	headers: {
		// 		"Content-Type": "application/json"				
		// 	}
		// }
		//const resp = useMock? IOTSimdetails : yield apiClient.post(API.GET_IOT_SIMDETAILS, apiPayload,config);
		const globalData = yield select(selectors.globalData);
		ecpdId = globalData?.widgetInputParams?.ecpdId?.value ?? window?.mbtGlobal?.ecpdId ?? ""
		zipCode = globalData?.widgetInputParams?.zipCode?.value ??
			window?.mbtGlobal?.defaultBusinessZipCode ?? "30004"
		const resp = yield call(fetchData);
		if (resp) {
			yield put(WCMPSlice.setIOTSimdetails(resp));
		} else {
			//console.error("error in getIOTsimdetails");
		}

	} catch (e) {
		//yield put(WCMPSlice.setIOTSimdetails(false))
	} finally {
		yield put(WCMPSlice.setPageLoading(false));
	}
}
function* addIOTSimdetails(params) {
	yield put(WCMPSlice.setAPIError(false));
	yield put(WCMPSlice.setPageLoading(true));

	const config = {
		headers: {
			'Content-Type': 'application/json',
		}
	}
	const globalData = yield select(selectors.globalData);
	let responseAcc = "";
	let respInitCheckout = "";
	const sessionCartData =
		globalData?.sessionCartData?.apiResponse?.prospectFlowData;
	try {
		let requestBody = params.payload;
		const response = yield apiClient.post(
			API.ADD_IOT_SIMDETAILS,
			//"https://mbqa2.sdc.vzwcorp.com/mbt/prospect/cartcompsvc/shop/product/accessory/sim/addCart",
			requestBody,
			config
		);
		// const response = axios.post("https://mbqa2.sdc.vzwcorp.com/mbt/prospect/cartcompsvc/shop/product/accessory/sim/addCart", requestBody, {
		// 	headers: {
		// 	  'Content-Type': 'application/json'
		// 	}			  	
		//   });


		const globalData = yield select(selectors.globalData);

		const payloadAcc = {
			clientId: globalData?.widgetInputParams?.clientName?.value ?? window?.mbtGlobal?.clientId ?? "MBT",
			accountNumber: "",
			ecpdId: globalData?.widgetInputParams?.ecpdId?.value ?? window?.mbtGlobal?.ecpdId,
			loginUserId: globalData?.widgetInputParams?.mbLoginId?.value ?? globalData?.widgetInputParams?.loginUserId?.value ?? globalData?.widgetInputParams?.mbaUserId?.value ?? window?.mbtGlobal?.userId ?? "",
			rootEcpdId: globalData?.widgetInputParams?.ecpdId?.value ?? window?.mbtGlobal?.rootEcpdProfileId ?? "",
			channel: globalData?.widgetInputParams?.clientName?.value ?? "",
			csr: window?.mbtGlobal?.isCSR ?? "",
			csrRole: window?.mbtGlobal?.csrRole ?? "",
			csrId: window?.mbtGlobal?.csrId ?? "",
			csrFirstName: window?.mbtGlobal?.csrFirstName ?? "",
			csrLastName: window?.mbtGlobal?.csrLastName ?? "",
			csrEmail: window?.mbtGlobal?.csrEmail ?? "",
			csrRoleEligibleForCommerceOrdering: window?.mbtGlobal?.csrRoleEligibleForCommerceOrdering ?? ""
		}
		if (response?.data?.status?.success) {
			responseAcc = yield apiClient.post(
				API.ADD_ACCOUNT_DETAILS,
				//"https://mbqa2.sdc.vzwcorp.com/mbt/prospect/cartcompsvc/shop/product/accessory/sim/addCart",
				payloadAcc,
				config
			);
			// if (responseAcc?.status === 200 && !!responseAcc?.data && (responseAcc?.data?.status?.success || responseAcc?.data?.response?.businessInfo?.bussinessName)) {
			// 	yield call(getManagerApprovalInfo)
			// }
			yield put(WCMPSlice.setAccountdetailsResp(responseAcc));

		}
		else {
			yield put(
				WCMPSlice.setErrorInfo({
					errResponse: response,
					status: "FAILED",
					errorStatusCode: response?.data?.status?.statusCode,
					errorStatusMessage: response?.data?.status?.statusMessage

				})
			);
			if (
				response?.data?.status?.statusCode === "411" || response?.data?.status?.statusMessage === "WCP_QUALITY_UNAVAILABLE" ||
				response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_ACCESSORY_DETAILS" ||
				response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_SIM_DETAILS "
			) {
				yield put(WCMPSlice.setErrorResponse(true));
			}

		}
		if (response?.data?.status?.success) {
			if ((responseAcc?.status === 200 && !!responseAcc?.data && (responseAcc?.data?.status?.success || responseAcc?.data?.response?.businessInfo?.bussinessName))) {
				yield call(getSessionCartInfo);
			}
			if ((responseAcc?.status === 200 && !!responseAcc?.data && (responseAcc?.data?.status?.success || responseAcc?.data?.response?.businessInfo?.bussinessName))) {
				//respInitCheckout	=yield call (initializeCheckout);
			}
			else {
				yield put(
					WCMPSlice.setErrorInfo({
						errResponse: responseAcc,
						status: "FAILED",
						errorStatusCode: responseAcc?.data?.status?.statusCode,
						errorStatusMessage: responseAcc?.data?.status?.statusMessage

					})
				);
				yield put(WCMPSlice.setErrorResponse(true));
			}
		}
		yield put(WCMPSlice.setAddtoCartResponse(respInitCheckout));
	} catch (err) {
		yield put(WCMPSlice.setAPIError(true));
	} finally {
		yield put(WCMPSlice.setPageLoading(false));
	}
}
export default function* actionWatcher() {
	yield takeLatest(WCMPSlice.getIOTSimdetails.type, getIOTSimdetails)
	yield takeLatest(WCMPSlice.addIOTSimdetails.type, addIOTSimdetails)
}